import { fetchActionsRequired as fetchActionsRequiredCall } from 'flux/clients/messages2';

import ActionTypes from './ActionTypes';

export interface Actions {
  fetchActionsRequired: (arg: { page: number; pageSize: number }) => void;
}

export default function actionsFactory(
  dispatch: (action: ActionTypes) => void,
): Actions {
  return {
    fetchActionsRequired: ({ page, pageSize }) => {
      dispatch({ type: 'ACTIONS_REQUIRED:FETCHING', payload: { page } });

      fetchActionsRequiredCall({ page, pageSize })
        .then((result) =>
          dispatch({
            type: 'ACTIONS_REQUIRED:FETCHING_SUCCESS',
            payload: { result },
          }),
        )
        .catch((error) =>
          dispatch({
            type: 'ACTIONS_REQUIRED:FETCHING_ERROR',
            payload: { error },
          }),
        );
    },
  };
}
